import {
  Badge,
  Box,
  Button,
  Grid,
  ListItem,
  Paper,
  Skeleton,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxInDesktop";
import TimeRangeSelector from "../../components/layouts/common/TimeRangeSelector";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { getCampApi } from "../../apis/camp.api";
import { StyledSearchBar } from "../../components/inputs/SearchBar";
import { getProductApi } from "../../apis/product.api";
import {
  getCityApi,
  getCountryApi,
  getStateApi,
} from "../../apis/CountryStateCity.api";
import CustomInput from "../../components/inputs/CustomInput";
import SubmitButton from "../../components/button/SubmitButton";
import AsynSearchBar from "../../components/inputs/AsynSearchBar";
import DataTable from "../../components/tables/DataTable";
import DrawerFilter from "./DrawerFilter";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import ButtonComponentsUi from "../../components/button/ButtonComponentsUi";
import { findObjectKeyByValue } from "../../utils/helper";
import { LEVEL_OF_HEARING_LOSS } from "../../utils/beneficiary.constant";
const FilterTitleBox = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
const FiltersBox = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",

  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
const ListUi = ({
  title,
  exportzipLoading,
  filters,
  setFilters,
  list,
  exportLoading,
  loading,
  onExportBtnClick,
  columns,
  callBackFun,
  handleDownload,
  data,
  loading1,
}) => {
  const navigate = useNavigate();
  const onCreateButtonClick = () => {
    navigate("/beneficiary/add/");
  };
  const [openFilter, setOpenFilter] = React.useState(false);
  return (
    <>
      <Box mb={3}>
        <Paper elevation={2} sx={{ width: "100%", padding: 4 }}>
          <Box mb={3}>
            <FilterTitleBox>
              <Typography variant="h5" mb={2}>
                {title} {filters.camp_name ? `( ${filters.camp_name} )` : ""} {filters.user_name ? `( ${filters.user_name} )` : ""}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 3 }}>
                {/* <Button variant="contained" onClick={onCreateButtonClick}>
                  Create
                </Button> */}
                <Badge
                  color="error"
                  variant="dot"
                  invisible={
                    filters.camp ||
                    filters.camp_name ||
                    filters.country ||
                    filters.state ||
                      filters.district ||
                      filters.user ||
                    filters.taluka
                      ? false
                      : true
                  }
                >
                  <Button
                    variant="outlined"
                    startIcon={<HiOutlineAdjustmentsHorizontal />}
                    onClick={() => setOpenFilter(true)}
                  >
                    Filters
                  </Button>
                </Badge>
              </Box>
            </FilterTitleBox>

            <DrawerFilter
              open={openFilter}
              onClose={(localFilters) => {
                setOpenFilter(false);
                setFilters({ ...filters, ...localFilters });
              }}
              filters={filters}
              setFilters={setFilters}
              onApply={(values) => {
                setFilters({
                  ...values,
                });
                setOpenFilter(false);
              }}
              onClear={() => {
                setFilters({
                  ...filters,
                  camp: "",
                  camp_name: "",
                  country: "",
                  taluka: "",
                  state: "",
                  district: "",
                });
              }}
            />
          </Box>
          {/* <BenificiaryCounts setFilters={setFilters} filters={filters} /> */}
          <Box
            mt={3}
            mb={3}
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(4, 1fr)",
              },
              gap: 2,
              width: "100%",
            }}
          >
            {" "}
            {loading1
              ? [0, 1, 2, 3].map((i) => (
                  <Grid item xs={12} md={3} key={i}>
                    <Paper component={Box} p={2}>
                      <Skeleton variant="rounded" height="120px" width="100%" />
                    </Paper>
                  </Grid>
                ))
              : Object.entries(data?.[0] || {})
                  .sort(([a], [b]) => {
                    // show ALL (8) first
                    if (Number(a) === 8) return -1;
                    if (Number(b) === 8) return 1;

                    return Number(a) - Number(b);
                  })
                  .map(([key, count]) => (
                    <ButtonComponentsUi
                      key={key}
                      width="100%"
                      colorType={Number(key) === filters.hearingLoss}
                      Title={
                        Number(key) === 8
                          ? "ALL"
                          : findObjectKeyByValue(
                              Number(key),
                              LEVEL_OF_HEARING_LOSS,
                            )
                              ?.replaceAll("_", " ")
                              ?.toUpperCase()
                      }
                      count={count}
                      onSubmit={() => {
                        setFilters({
                          ...filters,
                          hearingLoss: Number(key),
                        });
                      }}
                    />
                  ))}
          </Box>

          <FiltersBox mb={3}>
            <PaddingBoxInDesktop sx={{ display: "flex", flex: 1 }}>
              <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                <Box mr={1}>
                  {
                    <SubmitButton
                      loading={exportLoading}
                      variant="contained"
                      onClick={onExportBtnClick}
                      title={"Export CSV"}
                    />
                  }
                </Box>
                <Box>
                  {filters?.camp && (
                    <SubmitButton
                      loading={exportzipLoading}
                      variant="contained"
                      onClick={handleDownload}
                      title={"Export zip"}
                    />
                  )}
                </Box>
              </Box>
            </PaddingBoxInDesktop>

            <PaddingBoxInDesktop
              mb={2}
              sx={{
                display: "flex",
                flex: 1,
                justifyContent: "flex-end",
                "*": {
                  justifyContent: "center",
                },
              }}
              pl={2}
            >
              <AsynSearchBar
                sx={{ width: "100%", maxWidth: "280px" }}
                title="Search By  Name | Phone No "
                size="small"
                placeholder={"Search By  Name | Phone No "}
                defaultValue={filters.search}
                onChange={(changedVal) => {
                  setFilters({ ...filters, search: changedVal });
                }}
              />
            </PaddingBoxInDesktop>
          </FiltersBox>
          <Box sx={{ minHeight: "300px" }} className="table">
            <DataTable
              columns={columns}
              rows={list.result ? list.result : []}
              count={list.total ?? 0}
              filters={filters}
              setFilters={setFilters}
              loading={loading}
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default ListUi;
